// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormJobCosting } from '~/utils/interface/jobs';

export const schema = (t: TFunction): yup.ObjectSchema<IFormJobCosting> => {
  return yup.object().shape({
    deleteAdditionalExpenseIds: yup.array().optional(),
    additionalExpenses: yup
      .array()
      .of(
        yup.object().shape({
          description: yup
            .string()
            .trim()
            .required(t('common_validate_field_required', { ns: 'common/base' })),
          amount: yup
            .string()
            .trim()
            .required(t('common_validate_field_required', { ns: 'common/base' })),
        })
      )
      .min(1, t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValuesForm: IFormJobCosting = {
  additionalExpenses: [{ description: EMPTY_STRING, amount: EMPTY_STRING }],
};
